export default __webpack_public_path__ + "src/shared/svg/providers/6fef21329503f5a9b529ecfb17222cf1.png";